import React, { useState, useContext, useEffect } from "react";
import VerticalNavigation from "../components/VerticalNavigation";
import AuthContext from "../context/AuthContext";
import DataSplit from "../components/DataSplit";
import Spinner from "../components/loader";
import Swal from "sweetalert2";

const Classification = () => {
  const { authTokens } = useContext(AuthContext);
  const [procdata, setProcsData] = useState();
  const [loading, setLoading] = useState();

  let dataSplitting = async () => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/data_splitting/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
    });
    const data = await response.json();
    if (response.status === 200) {
      // console.log('data split:',data.Features);
      Swal.fire({
        title:"Success",
        icon:'success',
        text:"Data Spliting Done",
        confirmButtonText:'Ok'
      })
      setProcsData(data["Features"]);
      setLoading(false);
    }
    else{
      setLoading(false);
      Swal.fire({
        icon:'error',
        text:"Please Consider!.. All Required steps you have performed.",
        title:"Training",
        confirmButtonText:"Ok"

      })
    }
  };

  useEffect(() => {
    dataSplitting();
  }, []);

  //logistic regression
  // const [savemodel, setSaveModel] = useState(false);
  const [logreg, setLogReg] = useState();


  let logisticRegression = async (save) => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/logisticregression/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ save }),
    });
    const data = await response.json();
    if (response.status === 200) {
      Swal.fire({
        title:"Success",
        icon:'success',
        text:data['Msg'],
        confirmButtonText:'Ok'
      })
      setLogReg(data);
      setLoading(false);
    } else {
      Swal.fire({
        icon:'error',
        text:"Please Consider!.. All Required steps you have performed.",
        title:"Training",
        confirmButtonText:"Ok"

      })
      setLoading(false);
    }
  };

  ///decision tree classifer
  const [dtresponse, setDtResponse] = useState();


  let DtClassifier = async (save) => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/dtclassifier/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ save }),
    });
    const data = await response.json();
    if (response.status === 200) {
      Swal.fire({
        title:"Success",
        icon:'success',
        text:data['Msg'],
        confirmButtonText:'Ok'
      })
      setDtResponse(data);
      setLoading(false);
    } else {
      Swal.fire({
        icon:'error',
        text:"Please Consider!.. All Required steps you have performed.",
        title:"Training",
        confirmButtonText:"Ok"

      })
      setLoading(false);
    }
  };

  /// random forest
  const [randomeresponse, setRandomResponse] = useState();

  

  let RandomClassifier = async (save) => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/randomclassifier/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ save }),
    });
    const data = await response.json();
    if (response.status === 200) {
      Swal.fire({
        title:"Success",
        icon:'success',
        text:data['Msg'],
        confirmButtonText:'Ok'
      })
      setRandomResponse(data);
      setLoading(false);
    } else {
      Swal.fire({
        icon:'error',
        text:"Please Consider!.. All Required steps you have performed.",
        title:"Training",
        confirmButtonText:"Ok"

      })
      setLoading(false);
    }
  };

  ///SVC
  const [svcresponse, setSvcResponse] = useState();


  let svcClassifier = async (save) => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/svcclassifier/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ save }),
    });
    const data = await response.json();
    if (response.status === 200) {
      Swal.fire({
        title:"Success",
        icon:'success',
        text:data['Msg'],
        confirmButtonText:'Ok'
      })
      setSvcResponse(data);
      setLoading(false);
    } else {
      Swal.fire({
        icon:'error',
        text:"Please Consider!.. All Required steps you have performed.",
        title:"Training",
        confirmButtonText:"Ok"

      })
      setLoading(false);
    }
  };

  ///knn
  const [knnresponse, setKnnResponse] = useState();

  let knnClassifier = async (save) => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/knnclassifier/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ save }),
    });
    const data = await response.json();
    if (response.status === 200) {
      Swal.fire({
        title:"Success",
        icon:'success',
        text:data['Msg'],
        confirmButtonText:'Ok'
      })
      setKnnResponse(data);
      setLoading(false);
    } else {
      Swal.fire({
        icon:'error',
        text:"Please Consider!.. All Required steps you have performed.",
        title:"Training",
        confirmButtonText:"Ok"

      })
      setLoading(false);
    }
  };

  ///xgb classifier
  const [xgbresponse, setXgbResponse] = useState();
 

  let xgbClassifier = async (save) => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/xgbclassifier/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ save }),
    });
    const data = await response.json();
    if (response.status === 200) {
      Swal.fire({
        title:"Success",
        icon:'success',
        text:data['Msg'],
        confirmButtonText:'Ok'
      })
      setXgbResponse(data);
      setLoading(false);
    } else {
      Swal.fire({
        icon:'error',
        text:"Please Consider!.. All Required steps you have performed.",
        title:"Training",
        confirmButtonText:"Ok"

      })
      setLoading(false);
    }
  };

  return (
    <>
      <div className="wrapper">
        <VerticalNavigation />
        {loading ? <Spinner /> : null}

        <div className="container bg-light rounded main_content mx-2">
          <div className="model-body">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  data-bs-toggle="tab"
                  href="#datasplit"
                  role="tab"
                >
                  <span className="d-none d-sm-block">Data spliting</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#logr"
                  role="tab"
                >
                  <span className="d-none d-sm-block">Logistic Regression</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link "
                  data-bs-toggle="tab"
                  href="#dtc"
                  role="tab"
                >
                  <span className="d-none d-sm-block">
                    Decision Tree Classifier
                  </span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#rfc"
                  role="tab"
                >
                  <span className="d-none d-sm-block">
                    Random Forest Classifier
                  </span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#svc"
                  role="tab"
                >
                  <span className="d-none d-sm-block">
                    Support Vector Classfier
                  </span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#knnc"
                  role="tab"
                >
                  <span className="d-none d-sm-block">
                    K-Neirest Neighbor Classifier
                  </span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#xgbr"
                  role="tab"
                >
                  <span className="d-none d-sm-block">XGBOOST Classifier</span>
                </a>
              </li>
            </ul>

            <div className="tab-content p-3">
              <div className="tab-pane active" id="datasplit" role="tabpanel">
                <h3 className="text-center">
                  Spliting Training and Testing data....
                </h3>
                <div className="d-flexjustify-content-between flex-wrap">
                  {procdata && <DataSplit procdata={procdata} />}
                </div>
              </div>
              <div className="tab-pane" id="logr" role="tabpanel">
                <h3 className="text-center">Logistic Regression....</h3>
                <div className="d-flexjustify-content-between flex-wrap">
                  <div className="d-flex">
                    <button
                      className="btn btn-success my-5 mx-5"
                      onClick={()=>logisticRegression(false)}
                    >
                      Train
                    </button>
                    <button
                      className="btn btn-warning mx-5 my-5"
                      onClick={()=>logisticRegression(true)}
                    >
                      Train&Save
                    </button>
                  </div>
                  <div className="my-5">
                    {logreg && (
                      <table>
                        <thead>
                          <tr>
                            <th>Model Name</th>
                            <th>Accuracy</th>
                            <th>Precision</th>
                            <th>Recall</th>
                            <th>F1-Score</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Logistic Regression</td>
                            <td>{logreg["Accuracy"]}</td>
                            <td>{logreg["Precision"]}</td>
                            <td>{logreg["Recall"]}</td>
                            <td>{logreg["F1_Score"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="dtc" role="tabpanel">
                <h3 className="text-center">
                  Decision Tree Classification....
                </h3>
                <div className="justify-content-between flex-wrap">
                  <div className="d-flex">
                    <button
                      className="btn btn-success my-5 mx-5"
                      onClick={()=>DtClassifier(false)}
                    >
                      Train
                    </button>
                    <button
                      className="btn btn-warning mx-5 my-5"
                      onClick={()=>DtClassifier(true)}
                    >
                      Train&Save
                    </button>
                  </div>
                  <div className="my-5">
                    {dtresponse && (
                      <table>
                        <thead>
                          <tr>
                            <th>Model Name</th>
                            <th>Accuracy</th>
                            <th>Precision</th>
                            <th>Recall</th>
                            <th>F1-Score</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Decision Tree Classifier</td>
                            <td>{dtresponse["Accuracy"]}</td>
                            <td>{dtresponse["Precision"]}</td>
                            <td>{dtresponse["Recall"]}</td>
                            <td>{dtresponse["F1_Score"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="rfc" role="tabpanel">
                <h3 className="text-center">
                  Random Forest Classification....
                </h3>
                <div className="justify-content-between flex-wrap">
                  <div className="d-flex">
                    <button
                      className="btn btn-success my-5 mx-5"
                      onClick={()=>RandomClassifier(false)}
                    >
                      Train
                    </button>
                    <button
                      className="btn btn-warning mx-5 my-5"
                      onClick={()=>RandomClassifier(true)}
                    >
                      Train&Save
                    </button>
                  </div>
                  <div className="my-5">
                    {randomeresponse && (
                      <table>
                        <thead>
                          <tr>
                            <th>Model Name</th>
                            <th>Accuracy</th>
                            <th>Precision</th>
                            <th>Recall</th>
                            <th>F1-Score</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Random Forest Classifier</td>
                            <td>{randomeresponse["Accuracy"]}</td>
                            <td>{randomeresponse["Precision"]}</td>
                            <td>{randomeresponse["Recall"]}</td>
                            <td>{randomeresponse["F1_Score"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="svc" role="tabpanel">
                <h3 className="text-center">
                  Support Vector Classification....
                </h3>
                <div className="justify-content-between flex-wrap">
                  <div className="d-flex">
                    <button
                      className="btn btn-success my-5 mx-5"
                      onClick={()=>svcClassifier(false)}
                    >
                      Train
                    </button>
                    <button
                      className="btn btn-warning mx-5 my-5"
                      onClick={()=>svcClassifier(true)}
                    >
                      Train&Save
                    </button>
                  </div>
                  <div className="my-5">
                    {svcresponse && (
                      <table>
                        <thead>
                          <tr>
                            <th>Model Name</th>
                            <th>Accuracy</th>
                            <th>Precision</th>
                            <th>Recall</th>
                            <th>F1-Score</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>SVCClassifier</td>
                            <td>{svcresponse["Accuracy"]}</td>
                            <td>{svcresponse["Precision"]}</td>
                            <td>{svcresponse["Recall"]}</td>
                            <td>{svcresponse["F1_Score"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="knnc" role="tabpanel">
                <h3 className="text-center">
                  K-Nearest Neighbor Classification....
                </h3>
                <div className="justify-content-between flex-wrap">
                  <div className="d-flex">
                    <button
                      className="btn btn-success my-5 mx-5"
                      onClick={()=>knnClassifier(false)}
                    >
                      Train
                    </button>
                    <button
                      className="btn btn-warning mx-5 my-5"
                      onClick={()=>knnClassifier(true)}
                    >
                      Train&Save
                    </button>
                  </div>
                  <div className="my-5">
                    {knnresponse && (
                      <table>
                        <thead>
                          <tr>
                            <th>Model Name</th>
                            <th>Accuracy</th>
                            <th>Precision</th>
                            <th>Recall</th>
                            <th>F1-Score</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>KNNClassifier</td>
                            <td>{knnresponse["Accuracy"]}</td>
                            <td>{knnresponse["Precision"]}</td>
                            <td>{knnresponse["Recall"]}</td>
                            <td>{knnresponse["F1_Score"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="xgbr" role="tabpanel">
                <h3 className="text-center">XGboost Classfication....</h3>
                <div className="justify-content-between flex-wrap">
                  <div className="d-flex">
                    <button
                      className="btn btn-success my-5 mx-5"
                      onClick={()=>xgbClassifier(false)}
                    >
                      Train
                    </button>
                    <button
                      className="btn btn-warning mx-5 my-5"
                      onClick={()=>xgbClassifier(true)}
                    >
                      Train&Save
                    </button>
                  </div>
                  <div className="my-5">
                    {xgbresponse && (
                      <table>
                        <thead>
                          <tr>
                            <th>Model Name</th>
                            <th>Accuracy</th>
                            <th>Precision</th>
                            <th>Recall</th>
                            <th>F1-Score</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>XGBClassifier</td>
                            <td>{xgbresponse["Accuracy"]}</td>
                            <td>{xgbresponse["Precision"]}</td>
                            <td>{xgbresponse["Recall"]}</td>
                            <td>{xgbresponse["F1_Score"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Classification;
